(ns app.freshdesk.model)

(def ticket-type
  ["Analysis/Troubleshooting" "Best effort" "Bug" "Changes requested" "Correspondence/Marketing" "Customer Success"
   "Feature Request" "General Inquiry" "Incident" "Integrations" "Problem" "Question"])

(def product-type
  ["Building" "Bylaw/Code Enforcement" "Contractor Registration" "Land Use" "Licensing" "Planning"
   "Public Works Permits" "Public Works Orders" "N/A"])

(def related-feature-functionality
  ["AMANDA" "API" "Application Data" "Application Status" "Application Wizard" "Approver Groups"
   "Archiving" "Article Feedback" "Attachments" "Backend software integration" "Bluebeam" "Billing"
   "Categories/Work Types/Work Targets" "Change order/Amendment" "Change workspace municiaplity"
   "Changes requested" "Circulation" "Complaint View" "Conditions" "Configuration" "Content package"
   "Contractor View" "Custom" "Dashboard" "Data Importer" "Delete/Remove Workspace" "DigEplan" "Digital Invite"
   "Dispatching" "Email domain update" "Emails" "Escrow" "Fees Management" "FreshDesk Account Activation"
   "Forms" "Forms (New)" "Forms (updates)" "GIS" "Google Cloud Storage" "ICC" "Inspection Mobile App" "Inspections"
   "Inspections Error - 11/5" "Integrations" "Internal Notes" "Laserfiche" "Licensing View" "Link workspaces" "Log in"
   "Marketing/ Promotional" "Meetings" "Messages" "Mobile App" "MPAC" "My Today" "N/A" "Not technical/Contact municipality"
   "Notifications" "NYS Code report" "Online payment" "Organizational Admin Role" "Orders" "Other" "Out Of Office"
   "Page Not Found" "Parties to the application" "Password reset" "PDF Regeneration" "Permit Numbering" "Pre-consultation"
   "Process" "Project View" "Property Data Management" "Property Information" "Public map search" "Re-issue permit"
   "Remove Party for Authority User" "Renewal" "Reporting" "Reviews" "Search feature" "Sign-off" "Solar App" "SSO" "StatCan"
   "Subscribers" "Supplemental permits" "Tasks and Requests" "Technical issue" "Templates" "Templates (New)" "Templates (Updates)"
   "Timeline Processing" "Training Requests" "Transfer of Permit" "Turn on feature flag" "Unlock tasks"
   "Update workspace location/Verify property details" "User login" "User management" "WCAG/AODA" "365/Exchange" "Draft Access"])
